/** Return the months to show in the dropdown. */
export function getMonthOptions(displayMonth, navStart, navEnd, formatters, dateLib) {
  var startOfMonth = dateLib.startOfMonth,
    startOfYear = dateLib.startOfYear,
    endOfYear = dateLib.endOfYear,
    eachMonthOfInterval = dateLib.eachMonthOfInterval,
    getMonth = dateLib.getMonth;
  var months = eachMonthOfInterval({
    start: startOfYear(displayMonth),
    end: endOfYear(displayMonth)
  });
  var options = months.map(function (month) {
    var label = formatters.formatMonthDropdown(month, dateLib);
    var value = getMonth(month);
    var disabled = navStart && month < startOfMonth(navStart) || navEnd && month > startOfMonth(navEnd) || false;
    return {
      value: value,
      label: label,
      disabled: disabled
    };
  });
  return options;
}